
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/twitter-fashion-index",
      function () {
        return require("private-next-pages/twitter-fashion-index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/twitter-fashion-index"])
      });
    }
  